import React from "react";

export function KPICard({ label, value, sub, accent = "volt", trend, testId }) {
  const accentColor = accent === "volt" ? "text-volt" : accent === "danger" ? "text-red-500" : accent === "warning" ? "text-yellow-400" : "text-green-500";
  return (
    <div
      data-testid={testId}
      className="bg-[#0c0c0c] border border-zinc-900 rounded-md p-5 inset-hi hover:border-zinc-700 transition-colors duration-150 group"
    >
      <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 font-semibold">{label}</div>
      <div className={`font-display text-5xl font-black mt-2 leading-none ${accentColor}`}>
        {value}
      </div>
      {sub && <div className="mt-3 text-xs text-zinc-500">{sub}</div>}
      {trend != null && (
        <div className={`mt-1 text-xs ${trend >= 0 ? "text-green-400" : "text-red-400"}`}>
          {trend >= 0 ? "▲" : "▼"} {Math.abs(trend)}%
        </div>
      )}
    </div>
  );
}

export function PanelHeader({ title, subtitle, action }) {
  return (
    <div className="flex items-end justify-between mb-4">
      <div>
        <div className="text-[10px] uppercase tracking-[0.22em] text-zinc-500 font-semibold">{subtitle}</div>
        <h2 className="font-display text-3xl font-black uppercase tracking-tight mt-1">{title}</h2>
      </div>
      {action}
    </div>
  );
}

export function Panel({ children, className = "", ...rest }) {
  return (
    <div className={`bg-[#0c0c0c] border border-zinc-900 rounded-md p-5 inset-hi ${className}`} {...rest}>
      {children}
    </div>
  );
}

export function StatusDot({ color = "#00E676" }) {
  return (
    <span className="inline-block w-2 h-2 rounded-full" style={{ background: color, boxShadow: `0 0 8px ${color}` }} />
  );
}
